import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import QRCode from 'react-native-qrcode-svg';

import tw from '../../../styles/tailwind';


function generateCode() {
  return `${new Date().valueOf()}`;
}


export default function MyQRCode({ size = 200 }: { size?: number }) {
  const [codeValue, setCodeValue] = useState(generateCode());

  useEffect(() => {
    const interval = setInterval(() => {
      setCodeValue(generateCode());
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  return (
    <View>
      <QRCode
        value={codeValue}
        color={'white'}
        backgroundColor={tw.color('secondary')}
        size={size}
      />
    </View>
  );
}
